<template>
  <div class="liquidity-page min-w-0">
    <Head :title="__('Price zones')" />
    <Heading class="mb-4 md:mb-6">{{ __('Price zones') }}</Heading>
    <LiquidityApp
      :exchange="exchange"
      :refresh-ms="refreshMs"
      :api-base="apiBase"
    />
  </div>
</template>

<script setup>
import LiquidityApp from '../components/LiquidityApp.vue'

defineProps({
  exchange: {
    type: String,
    default: 'Binance',
  },
  refreshMs: {
    type: Number,
    default: 60000,
  },
  apiBase: {
    type: String,
    required: true,
  },
})
</script>
